module.exports = __webpack_public_path__ + "media/metal_hollow_3.efc3855f.mp3";